<template>
  <v-container fluid
               fill-height>
    <v-layout align-center
              justify-center
              column
              fill-height>
      <slot/>
    </v-layout>
  </v-container>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';

/**
 * Display data passed in slot in the center of the screen.
 */
@Component({
  name: 'CenteredContent',
})
export default class CenteredContent extends Vue {

}
</script>

<style lang="scss" module>

</style>



// WEBPACK FOOTER //
// src/layouts/CenteredContent.vue